module.exports = __webpack_public_path__ + "img/folder-magnifying-glass.e6b4f7bd.svg";